export default function formatNumber (value) {
  const decimales = 0
  const miles = ','
  const dec = '.'

  let n = value
  let c = Math.abs(decimales)
  if (isNaN(c)) {
    c = 2
  }

  let d = miles
  if (d === undefined) {
    d = ','
  }

  let t = dec
  if (t === undefined) {
    t = '.'
  }

  let s = ''
  if (n < 0) {
    s = '-'
  }

  const i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)))

  let j = i.length
  if (j > 3) {
    j = j % 3
  } else {
    j = 0
  }

  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
}
